import React, { memo } from 'react'
import { useSelector } from 'react-redux'

import useStyles from './balloonSummaryStyle'
import { GenerateSummary } from '../../molecules/chat/generateSummary'
import SummaryContent from '../../molecules/summary/summaryContent'
import { AutomaticallySummarize } from '../../molecules/chat/automaticallySummarize'

const BallonSummary = (props) => {
  const size = useSelector((state) => state.preferences)
  let useStylesParams = { size: size }
  const classes = useStyles(useStylesParams)

  if (props.data.summary) {
    return (
      <div className={classes.child}>
        <SummaryContent
          summaryText={props.data.summary}
          keywords={props.data.summaryKeywords}
          style={{ backgroundColor: 'unset' }}        />
        <AutomaticallySummarize />
      </div>
    )
  }

  if (!props.isSkillSummaryActived) return null

  return (
    <div className={classes.child}>
      <GenerateSummary
        conversationId={props.conversationId}
        messageId={props.data.currentId}
        isDisabled={props.data.summaryDisabled}
      />
    </div>
  )
}

export default memo(BallonSummary)
